define.alias("shared/components/shared/ui/flash-message", "media/components/shared/ui/flash-message");